import { defineFetch } from 'resift';

export default defineFetch({
  displayName: 'publish entity type',
  make: (entityTypeId: string) => ({
    key: [],
    request: (isActive: boolean) => ({ http }: any) =>
      http({
        method: 'PUT',
        route: `/entity-types/${entityTypeId}`,
        data: {
          isActive,
        },
      }),
  }),
});
